import { Routes, Route, Link, useParams, BrowserRouter, useLocation } from "react-router-dom";
import HomeNavTwoLg from "./HomeNavTwo";
import { HomeNavTwoPh } from "./HomeNavTwoph";
import Blc_facilities from "../../Blc_facilities/Blc_facilities";
import Blc_Gallery from "../../Blcs_Gallery/Blc_Gallery";
import Blc_Reservation from "../../Blc_Reservation/Blc_Reservation";
import Blc_Contact from "../../Blc_Contact/Blc_Contact";
import Blc_Faq from "../../Blc_FAQ/Blc_Faq";
import MediaQuery from "react-responsive";
import Blc_Locations from "../../Blc_Locations/Blc_Location";
import BlcFooter from "../../Blc_Common/Blc_Footer/Blc_footer";
import BlcSingleLocation from "../../Blc_Locations/Each_location/BlcSingleLocations";
import { useBlcLocations } from "../../Blc_Business/FristSixBLC/blcLocations";
import Spinner from "react-bootstrap/Spinner";
import Blc_Blog_Main from "../../Blc_News/Blc_Blog_Main";
import Blc_Blog from "../../Blc_News/Blc_Blog";
import { useBlcHighlights } from "../../Blc_Business/BlcHomeLandingPage/Blc_Highlights";
import ScrollToTop from "./ScrollToTop";
import HomeLanding from "../../Blc_Home/HomeLanding";
import Blc_Blog_Main_new from "../../Blc_News/Blc_Blog_Main_new";
import Blc_Blog_Main_new_copy from "../../Blc_News/Blc_Blog_Main_new_copy";
import HomeNavTwoLgCopy from "./HomeNavTwo_copy";
import AnimatedRoutes from "./AnimatedRoutes";
import HomeNavThreeLg from "./HomeNavThree";

//HomeNav called in the Home.js file

const HomeNavCopy = (props) => {
  //Window Resizing function. Basic work is Identify the screen size of different divice and display the component on based on the device screen size.

  const myVal = useBlcLocations();
  const newsFeed = useBlcHighlights();
  let { id } = useParams();
  // console.log( props.blcData.blc_highlights);

  const navData = [
    {
      tel: props.blcData.Blc_Tel,
      mail: props.blcData.blc_mail,
      logo: props.blcData.blc_logo.data[0].attributes.formats.small.url,
    }
  ]

  // console.log(navData);

  // console.log(props.blcData[2]);
  const blcIndex = (index) => {


    myVal[1](index);
  };

  const newsNumber = (valNum) => {

    newsFeed[1](valNum);
  }

  function waitFordata() {
    return (
      <>
        <div className="mySpin">
          <Spinner animation="border" />
        </div>
      </>
    );
  }

  // current page path 
  const pageLoc = useLocation().pathname;

  return (
    <>
      {/* Identify the device screen size and display the view based on the screen size. */}

      <MediaQuery minWidth={1024}>
        {/* <HomeNavTwoLg navDataLg={navData} navFeature={props.blcData.blc_feature} navDropDown={props.blcData.blc_locations_dropdwon} valIndex={blcIndex} /> */}
        {
          pageLoc === '/allnews' ? <HomeNavThreeLg navDataLg={navData} navFeature={props.blcData.blc_feature} navDropDown={props.blcData.blc_locations_dropdwon} valIndex={blcIndex} />
            : <HomeNavTwoLgCopy navDataLg={navData} navFeature={props.blcData.blc_feature} navDropDown={props.blcData.blc_locations_dropdwon} valIndex={blcIndex} />
        }
      </MediaQuery>
      <MediaQuery maxWidth={1023}>
        <HomeNavTwoPh navDataLg={navData} navFeature={props.blcData.blc_feature} />
      </MediaQuery>
      {/* All Navbar Routing Declare Here  */}
      <ScrollToTop>
        {/* <Routes>

          <Route

            path="/"
            element={
              <HomeLanding
                valHero={props.blcData.blc_hero_carousal}
                valAbout={props.blcData.blc_about_us}
                valFacilities={props.blcData.blc_facilites_services}
                valHighlights={props.blcData.blc_highlights}
                valDifLocations={props.blcData.blc_different_locations}
                valReservation={props.blcData.spotlight}
                valPartner={props.blcData.blc_partner}
                newsNum={newsNumber}
              />
            }
          />
          <Route path="/home" element={
            <HomeLanding
              valHero={props.blcData.blc_hero_carousal}
              valAbout={props.blcData.blc_about_us}
              valFacilities={props.blcData.blc_facilites_services}
              valHighlights={props.blcData.blc_highlights}
              valDifLocations={props.blcData.blc_different_locations}
              valReservation={props.blcData.spotlight}
              valPartner={props.blcData.blc_partner}
              newsNum={newsNumber}
            />
          } />
          <Route
            path="/locations"
            element={
              <Blc_Locations
                navDataPh={props.blcData.blc_locations_dropdwon}
                valIndex={blcIndex}
              />
            }
          />
          <Route path="/facilities" element={<Blc_facilities valFacility={props.facilityData} />} />
          <Route path="/gallery" element={<Blc_Gallery valGallery={props.blcGalleryData} />} />
          <Route path="/reservation" element={<Blc_Reservation valReservation={props.blcReservationData} />} />
          <Route path="/faq" element={<Blc_Faq valFaq={props.faqsData} />} />
          <Route path="/contact" element={<Blc_Contact valContactData={props.contactPageData} />} />
        
          <Route path="/blchighlights" element={<Blc_Blog_Main_new_copy valNewsIndex={newsFeed[0]} valHighlights={props.blcData.blc_highlights} />} />
          <Route path="/allnews" element={<Blc_Blog valHighlights={props.blcData.blc_highlights} newsNum={newsNumber} />} />
       
          <Route
            path="/locations/:locName"
            element={props.locationData !== undefined ? <BlcSingleLocation valIndex={myVal[0]} valData={props.locationData} /> : waitFordata()}
          />

        </Routes> */}
        <AnimatedRoutes props={props} />
      </ScrollToTop>
      <BlcFooter valFooter={props.blcData.blc_footer} />
    </>
  );
};

export default HomeNavCopy;
